<template>
  <!-- showHiddenFORMInputs {{ showHiddenFORMInputs }} -->
  <!-- modalTheme {{ modalTheme }} -->
  <div :class="userStore.borderClass">
    <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->

    <b-form inline @submit.prevent="onSubmit" @reset.prevent="onReset" :class="modalTheme">
      <!-- // THIS ACTIVATES the DROP DOWN filter -->
      <b-form-group v-show="showHiddenFORMInputs" id="useCurrentStatus" label="SHOW ALL Measures" label-for="showAllMeasures" size="sm">
        <b-input-group>
          <b-input-group-prepend is-text size="sm">
            <b-form-checkbox :class="modalTheme" switch class="mr-n2" v-model="form.measuresFilters.showAllMeasures" @change="setFormToStore()" size="sm">
              <span class> {{ form.measuresFilters.showAllMeasures }}</span>
              <pre hidden class="language-json"><code style="color:yellow;">{{ form.measuresFilters.showAllMeasures }}</code></pre>
            </b-form-checkbox>
          </b-input-group-prepend>
          <!-- <b-form-select v-model="form.measuresFilters.patientStatus" :options="patientStatusOptions" @change="setFormToStore()" size="sm"></b-form-select> -->
          <!-- <pre  class="language-json"><code style="color:yellow;">{{ form.measuresFilters.patientStatus  }}</code></pre> -->
        </b-input-group>
      </b-form-group>

      <b-form-group id="selectedPatientProvider" label="Provider: " label-for="selectedPatientProvider">
        <b-form-select
          :class="modalTheme"
          v-model="form.measuresFilters.providerName"
          :options="workListStore.getContractMeasuresFilters.providerNamesList"
          @change="setFormToStore()"
          size="sm"
        ></b-form-select>
        <h3 hidden class="language-json">
          <code style="background-color: black; color: lime">{{ workListStore.getContractMeasuresFilters.providerNamesList }}</code>
        </h3>

        <h3 hidden class="language-json">
          <code style="background-color: black; color: yellow">{{ form.measuresFilters.providerNamesList }}</code>
        </h3>
        <h4 hidden class="language-json">
          <code style="background-color: black; color: cyan"> {{ form.measuresFilters.providerName }}</code>
        </h4>
      </b-form-group>

      <!-- <b-form-group id="selectProvider" label="Provider: " label-for="selectProvider">
				<b-form-select v-model="selectedProvider" :options="getContractMeasuresFilters.providerNamesList" @change="setFormToStore()" size="sm"></b-form-select>
				<h3  class="language-json">
					<code style="background-color:black;color:yellow;">{{ selectedProvider }}</code>
				</h3>
			</b-form-group> -->
      <b-form-group v-show="showHiddenFORMInputs" id="selectMeasuresYear" label="Measures Year :  " label-for="selectMeasuresYear">
        <b-form-select v-model="selectedMeasureYear" :options="workListStore.getContractMeasuresFilters.measuresYearsList" @change="setFormToStore()" size="sm"></b-form-select>
        <!-- <b-form-select v-model="form.measuresFilters.measuresYear" :options="getContractMeasuresFilters.measuresYears"  @change="setFormToStore()" size="sm"></b-form-select> -->
        <h3 class="language-json">
          <code style="background-color: rgb(10, 115, 190); color: cyan">{{ selectedMeasureYear }}</code>
        </h3>
      </b-form-group>

      <b-form-group id="showCompletedPatients" label="Completed: " label-for="showCompletedPatients" size="sm">
        <b-form-checkbox :class="modalTheme" switch class="mr-n2" v-model="form.measuresFilters.showAllMeasuresCompletedPatients" @change="setFormToStore()" size="sm">
          <span :class="modalTheme"> {{ form.measuresFilters.showAllMeasuresCompletedPatients }}</span>
          <pre hidden class="language-json"><code style="color:yellow;">{{ form.measuresFilters.showAllMeasuresCompletedPatients }}</code></pre>
        </b-form-checkbox>
        <!-- <b-input-group :class="modalTheme"> -->
        <!-- <b-input-group-prepend is-text size="sm" :class="modalTheme"> </b-input-group-prepend> -->
        <!-- <b-form-select v-model="form.measuresFilters.patientStatus" :options="patientStatusOptions" @change="setFormToStore()" size="sm"></b-form-select> -->
        <!-- <pre  class="language-json"><code style="color:yellow;">{{ form.measuresFilters.patientStatus  }}</code></pre> -->
        <!-- </b-input-group> -->
      </b-form-group>
      <!-- // NEW      -->

      <b-form-group v-show="showHiddenFORMInputs" id="isMeasuresStatusComplete" label="Status Completed: " label-for="isMeasuresStatusComplete" size="sm">
        <b-input-group>
          <b-input-group-prepend is-text size="sm">
            <b-form-checkbox switch class="mr-n2" v-model="form.measuresFilters.isMeasuresStatusComplete" @change="setFormToStore()" size="sm">
              <span class> {{ form.measuresFilters.isMeasuresStatusComplete }}</span>
              <pre class="language-json"><code style="color:yellow;">{{ form.measuresFilters.isMeasuresStatusComplete }}</code></pre>
            </b-form-checkbox>
          </b-input-group-prepend>
        </b-input-group>
      </b-form-group>
    </b-form>
    <!-- <b-button type='button' variant='dark-green' @click='setLocalDateRanges'>setLocalDateRanges {{next7}}</b-button> -->
    <!-- <toggle-button switch-color='white' :width='90' :height='20' :font-size='14' :value='showForm' @change='onChangeShowForm' :color='{checked: '#7DCE94', unchecked: '#82C7EB'}' :labels='{checked: 'Current Date', unchecked: ' Filters '}' /> -->
    <div hidden>
      <b-card no-body class="overflow-hidden" style="min-width: 320px;max-width: 450px padding:0px">
        <template #header>
          <h6 v-b-toggle.logo class="mb-0">Status</h6>
        </template>
        <b-row no-gutters>
          <b-col></b-col>
          <b-collapse id="logo" class="mt-2">
            <b-col>
              <b-card-body title="MEASURES  Filters Status:">
                <b-card-text> This is a wider card with supporting text as a natural lead-in to additional content. This content is a little bit longer. </b-card-text>
                <div style="background-color: black">
                  <!-- <p>Counter from store</p> -->
                  <!-- <p>this.$store.state['workLists'].counter OUTSOURCED to COmpuTed Property</p> -->
                  <!-- <h6 style='color:blue'>compCounter {{compCounter}}</h6> -->
                  <!-- <h6 style='color:yellow'>filteredAllMyWork {{filteredAllMyWork.length}}</h6> -->
                  <b-row>
                    <!-- <b-col>
											<h6 style="color:cyan">fAMW: {{getMyWorkFilTaskStatusCount}}</h6>
										</b-col>

										<b-col>
											<h6 style="color:orange">fDMW:{{getMyDFilTaskStatusCount}}</h6>
										</b-col>
										<b-col>
											<h6 style="color:yellow">fOMW:{{getMyOFilTaskStatusCount}}</h6>
										</b-col>-->
                    <!-- <b-row style="background-color:darkgreen;color:yellow">currentDate: {{ this.currentDate }}</b-row> -->
                  </b-row>
                  <!-- <b-row style='background-color:yellow'>New: filterAllMyWOrk Count from My work {{getMyWorkFilteredCount}}</b-row> -->
                  <b-row style="background-color: black; color: lime; width: 100%">
                    <span style="color: white">providerName:</span>
                    {{ workListStore.getContractMeasuresFilters.providerNamesList }}
                  </b-row>
                  <!-- <b-row style="background-color:black;color:red;">
										<span style="color:white">End: {{getContractMeasuresFilters.selectedLastSeenDateRange.end}}</span>
									</b-row> -->
                  <!-- <b-row>
										<b-row style="background-color:black;color:lime;">
											<span style="color:white">selectedNextApptDateRange Start:</span>
											<span>{{getContractMeasuresFilters.selectedNextApptDateRange.start}}</span>
											<br />
										</b-row>
										<b-row style="background-color:black;color:red;">
											<span>End: {{getContractMeasuresFilters.selectedNextApptDateRange.end}}</span>
										</b-row>
										<span>{{getContractMeasuresFilters.selectedNextApptDateRange.start}}</span>
									</b-row> -->
                  <b-col>
                    <!-- <h6 style="background-color:darkblue;color:white">fAMW getMyWorkFilteredCount {{getMyWorkFilteredCount}}</h6> -->
                  </b-col>
                  <!-- <button @click='addOne'>Add 1</button>
			<button @click='addOneWithPayload'>Add 1 with PAYLOAD</button>
									<button @click='filterTHIS'>filterTHIS</button>-->
                </div>
              </b-card-body>
            </b-col>
          </b-collapse>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();

// & PROPS
const props = defineProps({
  providerNamesList: {
    Type: Array,
    Default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);
const showHiddenFORMInputs = ref(false);

const form = ref({
  measuresFilters: {
    showAllMeasures: workListStore.measuresFilters.showAllMeasures,

    providerName: workListStore.measuresFilters.providerNamesList[0],
    providerNamesList: workListStore.measuresFilters.providerNamesList,

    selectedMeasureYear: null,
    patientStatus: true,
    selectedPatientStatus: workListStore.measuresFilters.patientStatus,
    // providerNamesList: this.providerNamesList,

    showAllMeasuresCompletedPatients: workListStore.measuresFilters.showAllMeasuresCompletedPatients,
    isMeasuresStatusComplete: workListStore.measuresFilters.isMeasuresStatusComplete,

    // selectedLastSeenDateRange:	this.$store.state['workLists'].measuresFilters.selectedLastSeenDateRange,
    // nextAppt: this.$store.state['workLists'].measuresFilters.nextAppt,
    // selectedNextApptDateRange:this.$store.state['workLists'].measuresFilters.selectedNextApptDateRange,

    // userSelectedDate:this.$store.state['workLists'].measuresFilters.userSelectedDate,
    // taskTypes: this.$store.state['workLists'].measuresFilters.taskTypes,
    // patientStatus:this.$store.state['workLists'].measuresFilters.patientStatus,
    // selectedDateRange:this.$store.state['workLists'].measuresFilters.selectedDateRange,
    // useCurrentDateFilter:	this.$store.state['workLists'].measuresFilters.useCurrentDateFilter,
    // // useTaskFilter:	this.$store.state['workLists'].measuresFilters.useTaskFilter,
  },
});

function onSubmit(e) {
  // console.clear()
  // console.log("form onSubmit ", e);
  // // // console.log(e)
  // // console.log(this.form.measuresFilters.providerName)
  // this.getOptions(this.form.measuresFilters.providerName)
}
function onReset(e) {
  //this.$store.commit('resetFilterArray')

  this.form.measuresFilters.providerName = "";
  // this.form.measuresFilters.nextAppt == 0

  // this.form.measuresFilters.selectedDateRange = null

  workListStore.getContractMeasuresFilters();
}

function setFormToStore(e) {
  // console.log("  setFormToStore  CHECK ");
  // console.log();
  // console.log(form.value.measuresFilters.providerName);
  // console.log();
  // console.log();
  // console.log();

  workListStore.measuresFilters.providerName = form.value.measuresFilters.providerName;
  workListStore.measuresFilters.showAllMeasures = form.value.measuresFilters.showAllMeasures;
  workListStore.measuresFilters.showAllMeasuresCompletedPatients = form.value.measuresFilters.showAllMeasuresCompletedPatients;

  workListStore.measuresFilters.isMeasuresStatusComplete = form.value.measuresFilters.isMeasuresStatusComplete;

  // * NEW CHECK ADDED
  if (workListStore.measuresFilters.showAllMeasuresCompletedPatients) {
    workListStore.toggleMeasuresStatusComplete();
  }
}

onMounted(() => {
  // console.log("onMounted() :    BUILD  ContractMeasuresFilters >>>>");
  // console.log(" prop   providerNameList ");
  // console.log(props.providerNameList);
  // console.log(" ON CREATE function");
  // this.form.measuresFilters.providerNamesList = this.$store.state['workLists'].measuresFilters.providerNamesList
  // 	// this.getOptions()
  // 	console.log(' CM Filters CREATED')
  // 	console.log('this.getContractMeasuresFilters.providerNamesList')
  // 	console.dir(this.getContractMeasuresFilters.providerNamesList)
  // 	// this.selectedProvider = this.providerNamesList[0]
  // 	// // console.log(' selectedProvider  ')
  // 	console.log('		this.selectedProvider = this.providerNamesList[0]')
  // 	console.dir(this.selectedProvider)
  // 	if (this.selectedProvider === null || this.selectedProvider === undefined) {
  // 		// // console.log(' >>>>>>>>>>>>>>>>>>>>>>>>>>>>>> selectedProvider  IS NULL ')
  // 		this.selectedProvider = this.getContractMeasuresFilters.providerName
  // 		// // console.log( this.getContractMeasuresFilters.providerName)
  // 		// // console.log( this.selectedProvider )
  // 		return this.selectedProvider
  // }
  // else {
  // 	// this.selectedProvider = options[0]
  // 	this.selectedProvider = this.providerNamesList[0]
  // 	// 	//? Create NEW TASK : PAYLOAD
  // 	this.$emit('userselectedProvider', this.selectedProvider)
  // }
  // this.selectedProvider = this.getContractMeasuresFilters.providerName
});
</script>

<style lang="scss" scoped>
.measuresFiltersForm {
  border: 2px solid #dcf1de;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 05px;
  margin-left: 0%;
  //  background-color: #c6d9c8;
  /* height: 100px !important   b0c1b2*/
  /* max-width: 884px !important */
  width: auto !important;
  //  color: #eef8ef;
  font-weight: 700;
  font-size: 9pt;
  max-height: 305px;
}

.btn-primary-green {
  color: #007bff;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}
</style>
